import * as Types from '../Constants/AllConstants';

export const GetAllCurrenciesReducer = (state = { currencies: [] }, action) => {
  switch (action.type) {
    case Types.CURRENCY_LIST_REQUEST:
      return { loading: true, currencies: [] };
    case Types.CURRENCY_LIST_SUCCESS:
      return { loading: false, currencies: action.payload };
    case Types.CURRENCY_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const GetCurrenciesPagedReducer = (state = { currencies: [], page: 0, pages: 0 }, action) => {
  switch (action.type) {
    case Types.CURRENCY_PAGED_REQUEST:
      return { loading: true };
    case Types.CURRENCY_PAGED_SUCCESS:
      return {
        loading: false,
        currencies: action.payload.content,
        page: action.payload.number,
        pages: action.payload.totalPages,
      };
    case Types.CURRENCY_PAGED_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const CurrencyDetailsReducer = (state = { currency: {} }, action) => {
  switch (action.type) {
    case Types.CURRENCY_DETAILS_REQUEST:
      return { loading: true };
    case Types.CURRENCY_DETAILS_SUCCESS:
      return { loading: false, currency: action.payload };
    case Types.CURRENCY_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const CreateCurrencyReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.CURRENCY_CREATE_REQUEST:
      return { loading: true };
    case Types.CURRENCY_CREATE_SUCCESS:
      return { loading: false, success: true, currency: action.payload };
    case Types.CURRENCY_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case Types.CURRENCY_CREATE_RESET:
      return {};
    default:
      return state;
  }
};

export const UpdateCurrencyReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.CURRENCY_UPDATE_REQUEST:
      return { loading: true };
    case Types.CURRENCY_UPDATE_SUCCESS:
      return { loading: false, success: true, currency: action.payload };
    case Types.CURRENCY_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case Types.CURRENCY_UPDATE_RESET:
      return {};
    default:
      return state;
  }
};

export const DeleteCurrencyReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.CURRENCY_DELETE_REQUEST:
      return { loading: true };
    case Types.CURRENCY_DELETE_SUCCESS:
      return { loading: false, success: true };
    case Types.CURRENCY_DELETE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
